import script from "./rec-diagnosis-selector.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-diagnosis-selector.vue?vue&type=script&lang=ts&setup=true"

import "./rec-diagnosis-selector.vue?vue&type=style&index=0&id=e85a13d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e85a13d8"]])

export default __exports__